import {
    AppData,
    Colors,
    Img,
    Lightning,
    Router,
    Log,
    Registry,
} from "@lightningjs/sdk";
import { AppSetup } from "../lib/app-setup";
import GridViewModel, {
    FocusInfo,
} from "../lib/components/grid/grid-view-model";
import { ItemNode } from "../lib/components/grid/ItemNode";
import MultiRowGrid from "../lib/components/grid/multirow-grid";
import RowList from "../lib/components/grid/row-model";
import { Logger } from "../lib/logger";
import { GRIDTYPE } from "../lib/enum";
import { Helper } from "../lib/helper";
import childApp from "../lib/child-app";

export interface VideoPlaylistUITemplateSpec
    extends Lightning.Component.TemplateSpec {
    Background: object;
    Label: object;
    RowListWrapper: object;
    MultiRowGrid: object;
}

export default class VideoPlaylistUI
    extends Lightning.Component<VideoPlaylistUITemplateSpec>
    implements Lightning.Component<VideoPlaylistUITemplateSpec>
{
    Background = this.getByRef("Background")!;
    Label = this.getByRef("Label")!;
    RowListWrapper = this.getByRef("RowListWrapper")!;
    MultiRowGrid = this.getByRef("MultiRowGrid")!;
    _item: any;
    gridViewModel!: GridViewModel;
    playingVideoInfo!: FocusInfo;
    // private _focusAnimation: Lightning.types.Animation | undefined = undefined;

    autoHidePlaylistIntv: any;
    autoHidePlaylistTime = 6;
    autoHidePlaylistCnt = 0;
    playlistOn = true;
    isFocusedOnce = false;
    previousRowTitle = ''
    playlistRowMetaAlpha: number = 0;
    isResolvingItem = false;

    static override _template(): Lightning.Component.Template<VideoPlaylistUITemplateSpec> {
        return {
            // color: 0x88000000,
            // rect: true,
            w: (w: any) => w,
            h: (h: any) => VIDEO_PLAYLIST_HEIGHT,
            y: (h: any) => h, //-VIDEO_PLAYLIST_HEIGHT,
            BottomShader: {
                y: (h) => h + 570,
                w: (w) => w,
                h: 400,
                mountY: 1,
                rect: true,
                colorTop: 0x003B3B83,
                colorBottom: 0xFF0D0D1D,
                zIndex: 5,
            },
            RowListWrapper: {
                x: 48,
                y: 0,
                w: 1920,
                h: 380,
                clipping: true,
                zIndex: 1,
                MultiRowGrid: undefined,
            },
            ItemTitle: { x: 82, zIndex: 1, text: { text: '', fontSize: 30, fontFace: Helper.getFontFamily('Regular') } },
            // fontFace: 'Fresca',
        };
    }

    override _init() {
        //let w=1920;
        // let h = 1080;
        //let w = (w: any) => w;
        //let h = (h: any) => h;
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        this.gridViewModel = app?.loadVideoPlaylist();
        this.playingVideoInfo = {
            focusRow: this.gridViewModel.getFocusInfo().focusRow,
            foucsItem: this.gridViewModel.getFocusInfo().foucsItem,
        };
        this.gridViewModel.on("loaded", this._gridLoadedHandler, this);
        this.gridViewModel.on("focused", this._gridFocusedHandler, this);
        this.gridViewModel.on("selected", this._gridSelectedHandler, this);

        this.gridViewModel._init();

        // this._focusAnimation = this.animation({
        //     duration: 0.5,
        //     actions: [{ p: "y", v: { 0: h, 1: h - VIDEO_PLAYLIST_HEIGHT } }],
        // });
    }

    override _firstActive() { }

    override _focus() {
        Logger.processUserAction('playlistLaunch');
        // const { platform } = AppData as AppSetup;
        // const vodItem = this.gridViewModel.getFocusedItem()
        // platform?.textToSpeach(vodItem.title)
        // this.isFocusedOnce = true;
         this.fireAncestors("$playlistFocus");
        this._focusAnimation?.start();
        // this.startAutoHidePlaylistTimer();
        this.gridViewModel.changeFocus(this.playingVideoInfo);
        this.tag("MultiRowGrid")?.resetFocus?.(this.playingVideoInfo, this.playingVideoInfo.foucsItem);
    }

    override _unfocus() {
        //Logger.processUserAction('playlistClosed');
         this.fireAncestors("$playlistunFocus");
        // this.stopAutoHidePlaylistTimer();
        // this._focusAnimation?.stop();
    }

    override _getFocused() {
        return this.tag("MultiRowGrid");
    }

    override _detach() {
        this.gridViewModel.off("loaded", this._gridLoadedHandler, this);
        this.gridViewModel.off("focused", this._gridFocusedHandler, this);
        this.gridViewModel.off("selected", this._gridSelectedHandler, this);
        this.isFocusedOnce = false;
        this.stopAutoHidePlaylistTimer();
    }

    $handleUp(): boolean | void {
        // this.hidePlaylist();
        this.fireAncestors("$focusMediaButtons");
        return true;
    }

    override _handleBack(e: KeyboardEvent): boolean | void {
        this.hidePlaylist();
    }

    _removeEmptySimilarRow() {
        this._removeEmptyRow(GRIDTYPE.SIMILAR_VIDEOS);
    }

    /**
     * Drop a fetched-on-demand rail row that came back with no items, so the rail never shows an
     * empty row. Matched on RowList.description, which loadSimilarVideos/loadMoreChannels set to
     * the owning GRIDTYPE.
     */
    _removeEmptyRow(description: string) {
        const rowIndex = this.gridViewModel.uiList.findIndex(
            (uiRow: any) => uiRow.data?.item?.rowList?.description === description
        );
        if (rowIndex < 0) {
            return;
        }
        const rowList: RowList = this.gridViewModel.uiList[rowIndex].data.item.rowList;
        if (rowList.videos.length > 0) {
            return;
        }
        Log.info('VideoPlaylistUI: row returned no items, removing it', description, rowList.name);
        this.gridViewModel.remove(rowIndex);
    }

    _gridLoadedHandler(event: any) {
        this._removeEmptySimilarRow();
        this._removeEmptyRow(GRIDTYPE.MORE_CHANNELS);
        const style = Helper.getRowStyle(this.gridViewModel.getRowAt(0))
        this.patch({
            RowListWrapper: {
                h: style.row_height + 200,
                MultiRowGrid: {
                    x: 46,
                    y: 0,
                    w: (w: any) => w,
                    h: (h: any) => h,
                    grid: this.gridViewModel,
                    type: MultiRowGrid,
                    parentType: "playlist",
                    playlistRowMetaAlpha: this.playlistRowMetaAlpha,
                },
            },
        });
        this.gridViewModel.changeFocus(this.playingVideoInfo);
    }

    _gridFocusedHandler(event: any) {
        const { appState, platform } = AppData as AppSetup;
        const app = appState?.getApp();
        // let parentGrid = app?.navigation.getCurrentGrid();
        // const focusInfo: FocusInfo = parentGrid?.getFocusInfo()!
        // focusInfo.foucsItem = this.gridViewModel.getFocusInfo().foucsItem
        // const focusRow = this.gridViewModel.getRowAt(focusInfo.focusRow)
        // if (focusRow?.description == 'dynid') {
        //     parentGrid = app?.dynidGrid.changeFocus({ focusRow: focusInfo.focusRow, foucsItem: focusInfo.foucsItem })
        // }
        // parentGrid?.changeFocus(focusInfo);
        const vodItem = this.gridViewModel.getFocusedItem()
        const focusRow = this.gridViewModel.getRowAt(this.gridViewModel.getFocusInfo().focusRow)
        const rowStyle = Helper.getRowStyle(focusRow)
        const useHigherTitleY = rowStyle.rowstyle === 'flat-movie'
        if (vodItem && vodItem.title) {
            this.tag('ItemTitle')?.patch({
                y: useHigherTitleY ? 375 : 315,
                text: { text: vodItem.title }
            })
        }
        let tts = ''
        if(this.previousRowTitle !== focusRow?.name){
            tts += focusRow?.name
            this.previousRowTitle = focusRow?.name
        }
        tts += vodItem.title
        platform?.textToSpeach(tts)
        this.autoHidePlaylistCnt = 0
        this.fireAncestors("$resetInactivityTimer");
    }

    _gridSelectedHandler(event: any) {
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        let parentGrid = app?.navigation.getCurrentGrid();
        const currInfo = this.gridViewModel.getFocusedItem();
        if(app?.blockingManager.isItemBlocked(currInfo)){
            app.blockingManager.showBlockedNotification();
            return;
        }
        const focusRow = this.gridViewModel.getRowAt(this.gridViewModel.getFocusInfo().focusRow)
        appState?.sessionTimeState.stopTimer();

        if (focusRow?.description === GRIDTYPE.MORE_CHANNELS || Helper.isChildAppItem(currInfo)) {
            const page = Router.getActivePage();
            page?.hitCloseTracker()
            page?.closeVideo(true)
            this._launchChildApp(currInfo);
            return;
        }

        if (focusRow && (focusRow.description === GRIDTYPE.SIMILAR_VIDEOS || focusRow.description === GRIDTYPE.QUEUE)) {
            this._handleResolvedRowSelected(currInfo, focusRow.description);
            return;
        }

        const playingRow = this.gridViewModel.getRowAt(this.playingVideoInfo.focusRow)
        let isDynidSelected = false
        if (parentGrid?.type !== GRIDTYPE.DYNID && focusRow?.description == 'dynid') {
            //app?.dynidGrid.changeFocus({ focusRow: 0, foucsItem: focusInfo.foucsItem })
            if (parentGrid?.type === GRIDTYPE.SIMILAR_VIDEOS) {
                app?.navigation.continuesStack.pop()
            }
            app?.navigation.push(app.dynidGrid)
            parentGrid = app?.navigation.getCurrentGrid();
        } else {
            if(playingRow?.description == 'dynid' && focusRow?.description !== 'dynid') {
                app?.navigation.pop();
            }
            parentGrid = app?.navigation.getCurrentGrid();
        }
        let focusInfo: FocusInfo = parentGrid?.getFocusInfo()!
        focusInfo.foucsItem = this.gridViewModel.getFocusInfo().foucsItem
        parentGrid?.changeFocus(focusInfo);
        const vodInfo: ItemNode = this.gridViewModel.getFocusedItem();

        appState.player.pausedTime = 0;
        appState.player.videoStartedFromResumePoint = 0;
        Log.info(
            "MainGridTemplateSpec:_gridSelectedHandler: ",
            this.gridViewModel.getFocusInfo(),
            vodInfo
        );

        if (
            vodInfo.type == "listoflist" ||
            vodInfo.type == "new-qid" ||
            vodInfo.feed_type == "banner"
        ) {
            this._handleResolvedRowSelected(vodInfo, focusRow?.description || '');
        } else if (vodInfo.feed_type == "video") {
            this.fireAncestors("$reset");
            this._navigateToVideo(vodInfo.node_id, '_playlist_r_');
        }
    }

    /**
     * @method _launchChildApp
     * @description Open the site behind a "More Channels" tile in-app, reusing the same child-app
     * stack the grid screens and bug-ad launchInAppOpening action use. The current video is torn
     * down first via $reset (loadChildApp's loadIndex is async and Router navigation alone does
     * not stop playback), then a fresh AppModel for the target site is pushed and the router lands
     * on that site's main grid.
     * @param {ItemNode} vodInfo - The focused childapp node, carrying the target site_id.
     * @returns {boolean} true when the site switch was started.
     */
    _launchChildApp(vodInfo: ItemNode): boolean {
        const { appState, platform } = AppData as AppSetup;
        const app = appState?.getApp();
        const siteId = vodInfo?.site_id ? String(vodInfo.site_id) : '';

        if (!Helper.isValidValue(siteId) || siteId == '0') {
            Log.error('VideoPlaylistUI: _launchChildApp - invalid site id for', vodInfo?.title, siteId);
            return false;
        }
        // Compare against the platform-remapped id (loadChildApp remaps too), so a legacy site id
        // pointing back at the site we are already running is not stacked on itself.
        const targetSiteId = platform ? platform.remapSiteId(siteId) : siteId;
        if (app?.siteId == targetSiteId) {
            Log.info('VideoPlaylistUI: _launchChildApp - already running site', targetSiteId);
            return false;
        }

        Logger.processUserAction('newInAppOpeningFromVideoPlayer', siteId);

        // $reset(false): tear the video down without the loading banner - loadChildApp puts up the
        // plain spinner instead, and the multi-banner must not be requested at all here because
        // MultiBannerManager.getBanner() fires ad impressions.
        this.fireAncestors("$reset", false);
        this.hidePlaylist();
        childApp.loadChildApp({ site_id: siteId });
        return true;
    }

    _navigateToVideo(nodeId: string, suffix: string) {
        setTimeout(() => {
            Router.navigate("video-screen/" + nodeId + suffix + new Date().getTime(), false);
        }, 200);
    }

    _handleResolvedRowSelected(currInfo: ItemNode, rowDescription: string) {
        if (this.isResolvingItem) {
            return;
        }
        this.isResolvingItem = true;

        const isQueueRow = rowDescription === GRIDTYPE.QUEUE;
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        const page = Router.getActivePage();
        this.fireAncestors("$reset");

        const finishResolving = () => {
            this.isResolvingItem = false;
            page.widgets.loadingscreen.showVideoLoadingScreen(false);
        };

        app?.resolvePlayableItem(currInfo).then((resolved) => {
            const selectedItem = resolved.item;
            const pendingGrids = resolved.grids;
            if (app?.blockingManager.isItemBlocked(selectedItem)) {
                pendingGrids.forEach((g) => g.destroy());
                app.blockingManager.showBlockedNotification();
                finishResolving();
                return;
            }

            if (!selectedItem || selectedItem.feed_type !== "video") {
                Log.info('VideoPlaylistUI: no playable item resolved, opening MLP page instead', currInfo.id);
                pendingGrids.forEach((g) => g.destroy());
                finishResolving();
                Router.navigate(`mlp-grid-screen/${currInfo.id}`, false);
                return;
            }

            appState.player.pausedTime = 0;
            appState.player.videoStartedFromResumePoint = 0;

            const currentGrid = app?.navigation.getCurrentGrid();
            if (currentGrid?.type === GRIDTYPE.SIMILAR_VIDEOS || currentGrid?.type === GRIDTYPE.MLP || currentGrid?.type === GRIDTYPE.DYNID) {
                app?.navigation.pop();
            } else if (currentGrid?.type === GRIDTYPE.QUEUE) {
                app?.navigation.continuesStack.pop();
            }

            const sourceGrid = isQueueRow ? app?.queueGrid : app?.similarGrid;
            if (pendingGrids.length > 0) {
                pendingGrids.forEach((g) => {
                    if (app?.navigation && !app.navigation.continuesStack.includes(g)) {
                        app.navigation.push(g);
                    }
                });
            } else if (sourceGrid) {
                sourceGrid.focusInfo = { focusRow: 0, foucsItem: this.gridViewModel.getFocusInfo().foucsItem };
                app?.navigation.push(sourceGrid);
            }

            if (selectedItem.feed_type == "video") {
                /* XFIN-1658 */
                Logger.processUserAction(isQueueRow ? 'playingQueueVideoOnPlayerUI' : 'playingNewSimilarVideoOnPlayerUI', selectedItem.node_id);
                this.isResolvingItem = false;
                this._navigateToVideo(selectedItem.node_id, isQueueRow ? '_queue_r_' : '_similar_r_');
            } 
            finishResolving();
        }).catch((e) => {
            Log.error('VideoPlaylistUI: Failed to resolve selected item, skipping selection', rowDescription, e);
            finishResolving();
        });
    }

    startAutoHidePlaylistTimer = () => {
        this.stopAutoHidePlaylistTimer();
        this.autoHidePlaylistIntv = Registry.setInterval(() => {
            this.autoHidePlaylistCnt++
            if(this.autoHidePlaylistCnt >= this.autoHidePlaylistTime) {
                this.hidePlaylist();
            }
        }, 1000);
    };

    stopAutoHidePlaylistTimer = () => {
        this.autoHidePlaylistCnt = 0
        Registry.clearInterval(this.autoHidePlaylistIntv);
    };

    hidePlaylist = () => {
        this.playlistOn = false;
        this.stopAutoHidePlaylistTimer()
        this.fireAncestors("$hide");
    };

    setRowMetaAlpha(alpha: number) {
        this.playlistRowMetaAlpha = alpha;
        const grid: any = this.tag("RowListWrapper")?.tag("MultiRowGrid");
        if (grid && grid.setRowMetaAlpha) {
            grid.setRowMetaAlpha(alpha);
        }
    }
}
const VIDEO_PLAYLIST_HEIGHT = 610;
const controlsBGColorFocus = 0x88ff0000;
const controlsBGColorUnFocus = 0x8800ff00;
